export default "__VITE_ASSET__gtkZNYU6__"